/**
 * Central API base URL for frontend.
 * Avoids mixed content: when the app is served over HTTPS, API URL uses same protocol.
 * Never read or depend on Razorpay response headers (x-rtb-fingerprint-id, x-razorpay-*, etc.).
 */
function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) return envUrl.trim().replace(/\/+$/, '');
  if (typeof window === 'undefined') return 'http://localhost:5000';
  if (window.location.hostname === 'localhost') return 'http://localhost:5000';
  return `${window.location.protocol}//${window.location.host}`;
}

const base = getApiBaseUrl();
export const API_URL = base.endsWith('/api') ? base : `${base}/api`;

/**
 * Warm the Render backend on app load so cold start finishes
 * BEFORE the user submits any form.
 *
 * KEY FIXES vs previous version:
 *  1. Timeout raised from 15s → 100s  (Render cold start = 50–90s)
 *  2. Tries both /health and /api/health so it works regardless of your route
 *  3. Called from App.js on first load, not just Register page
 *  4. De-duplicated — only fires once per session via sessionStorage flag
 */
export function warmBackend() {
  if (typeof window === 'undefined') return;

  // Only ping once per browser session — no need to repeat on every page visit
  if (sessionStorage.getItem('backend_warmed')) return;
  sessionStorage.setItem('backend_warmed', '1');

  const root = base.endsWith('/api') ? base.replace(/\/api$/, '') : base;

  // Try /health first, fall back to /api/health
  // Whichever your backend has, one will succeed
  const urls = [`${root}/health`, `${root}/api/health`];

  urls.forEach(url => {
    const controller = new AbortController();
    // 100s — enough for any Render cold start
    const t = setTimeout(() => controller.abort(), 100_000);
    fetch(url, {
      method: 'GET',
      credentials: 'omit',
      signal: controller.signal,
    })
      .then(() => {
        console.log('[warmBackend] Server is warm ✓');
      })
      .catch(() => {
        // Silent — this is best-effort, not critical path
      })
      .finally(() => clearTimeout(t));
  });
}